var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 10.586L16.2427 6.34299C16.6332 5.95252 17.2663 5.95252 17.6567 6.34299C18.0472 6.73345 18.0472 7.36652 17.6567 7.75699L13.4137 12L17.6567 16.243C18.0472 16.6335 18.0472 17.2665 17.6567 17.657C17.2663 18.0475 16.6332 18.0475 16.2427 17.657L11.9997 13.414L7.75674 17.657C7.36628 18.0475 6.73321 18.0475 6.34274 17.657C5.95228 17.2665 5.95228 16.6335 6.34274 16.243L10.5857 12L6.34274 7.75699C5.95228 7.36652 5.95228 6.73345 6.34274 6.34299C6.73321 5.95252 7.36628 5.95252 7.75674 6.34299L11.9997 10.586Z",
    fill: "#2B2C82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/icon-cross.862af4f085422c4a80e0b59f0ebb065c.svg";
export { ForwardRef as ReactComponent };